import RulesForm from './RulesForm';
import RulesFormSchema from './RulesForm.schema';
export default RulesForm;
export { RulesFormSchema };
